var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.993,
    height: 120,
    viewBox: "0 0 96.993 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#c2b7db;}.b{fill:#582bb8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-55.111 -8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.051 44.774)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 9.677,
    cy: 9.677,
    r: 9.677,
    transform: "translate(36.984)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M211.871,456,208,465.677h23.226L227.355,456Z",
    transform: "translate(-172.951 -384.387)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M65.277,365.446,87.765,350.99l-4.2-27.21c-18.5,7.556-23.973,21.76-18.283,41.666Z",
    transform: "translate(-63.132 -284.156)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M350.542,324.05l-4.362,27.143,22.488,14.458C374.341,345.8,368.917,331.62,350.542,324.05Z",
    transform: "translate(-277.701 -284.361)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M240,365.29h7.742L245.806,344h-3.871Z",
    transform: "translate(-197.209 -299.484)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.111 8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M201.419,128a17.419,17.419,0,1,0,17.419,17.419A17.419,17.419,0,0,0,201.419,128Zm0,30.968a13.548,13.548,0,1,1,13.548-13.548A13.548,13.548,0,0,1,201.419,158.968Z",
    transform: "translate(-152.817 -98.968)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M219.613,152a11.613,11.613,0,1,0,11.613,11.613A11.613,11.613,0,0,0,219.613,152Zm0,19.355a7.742,7.742,0,1,1,7.742-7.742,7.742,7.742,0,0,1-7.742,7.742Z",
    transform: "translate(-171.011 -117.161)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M132.044,83.283l.854-5.318a1.194,1.194,0,0,0,.017-.131,79.06,79.06,0,0,0-4.972-36.486c-4.282-10.865-11.26-21.181-20.739-30.658l-2.122-2.124a1.939,1.939,0,0,0-2.739,0l-2.122,2.122c-9.479,9.479-16.456,19.8-20.739,30.66a79.061,79.061,0,0,0-4.972,36.486.991.991,0,0,0,.015.119l.81,5.255c-17.913,7.911-23.971,22.5-18,43.389a1.935,1.935,0,0,0,2.908,1.1l19.981-12.844.283,1.834a1.938,1.938,0,0,0,1.914,1.64H93.111L90.3,125.345A1.936,1.936,0,0,0,92.1,128h23.226a1.935,1.935,0,0,0,1.8-2.654l-2.809-7.023h10.447a1.936,1.936,0,0,0,1.911-1.629l.3-1.86,20,12.859a1.935,1.935,0,0,0,2.908-1.1c5.952-20.823-.051-35.388-17.835-43.314ZM60.387,123c-4.176-17.214.931-28.969,15.564-35.821L79.58,110.66Zm34.572,1.13,2.323-5.806h12.861l2.323,5.806Zm28.152-9.677H84.082l-.489-3.155c0-.007,0-.017,0-.027L78.361,77.423a75.221,75.221,0,0,1,4.723-34.655c4.089-10.369,10.776-20.24,19.877-29.342l.752-.755.752.755c9.1,9.1,15.789,18.972,19.877,29.342a75.236,75.236,0,0,1,4.723,34.65l-1.074,6.68a.04.04,0,0,1,0,.017ZM146.828,123l-19.185-12.336,3.764-23.417c14.521,6.861,19.582,18.593,15.421,35.753Z",
    transform: "translate(-55.111 -8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M241.67,337.76a1.935,1.935,0,0,0-1.927-1.76h-3.871a1.936,1.936,0,0,0-1.928,1.76l-1.935,21.29a1.935,1.935,0,0,0,1.927,2.111h7.742a1.936,1.936,0,0,0,1.928-2.111Zm-5.615,19.53,1.584-17.419h.336l1.584,17.419Z",
    transform: "translate(-189.204 -256.646)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M251.871,289.677v-7.742a1.935,1.935,0,1,0-3.871,0v7.742a1.935,1.935,0,0,0,3.871,0Z",
    transform: "translate(-201.334 -214.194)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M249.936,71.484a1.936,1.936,0,0,0,1.936-1.935V57.935a1.935,1.935,0,0,0-3.871,0V69.548A1.935,1.935,0,0,0,249.936,71.484Z",
    transform: "translate(-201.334 -44.387)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.09912922326dc6c4a038e8c9a9a1cceb.svg";
export { ForwardRef as ReactComponent };